/**
 * Sweep C-phase Item 1 (2026-07-21): the ONE status->label vocabulary for
 * the whole app. Internal status codes (e.g. "rfp_generated", "refined")
 * must never render to a user anywhere - every status display (dashboard
 * cards, the procurement detail page's workflow banner, admin's Users tab
 * and All Requests tab, anywhere else a procurement's `status` field is
 * shown) must go through getStatusLabel() from here instead of rendering
 * the raw field or maintaining its own local label map.
 *
 * Canonicalized from ProcurementDetail.jsx's original mapping - the
 * fullest, most descriptive labels already in production use there
 * (Dashboard.jsx previously had its own shorter, near-identical-to-the-
 * raw-code map, e.g. 'refined' -> 'Refined', which was effectively still
 * exposing the internal vocabulary under a thin coat of capitalization).
 */
export const STATUS_LABELS = {
  intake: 'Intake Complete - Ready for Uploads',
  questions_generated: 'Questions Generated - Ready to Answer',
  answers_provided: 'Answers Provided - Ready for Review',
  refined: 'Refined - Ready for Line Items',
  rfp_generated: 'RFP Generated - Ready for Risk Intelligence',
  completed: 'Completed',
};

// Graceful, non-blank fallback for a status code with no known label - an
// unrecognized code must never render blank, and per the rule above must
// never render the raw internal code either.
const UNKNOWN_STATUS_LABEL = 'Unknown Status';

export const getStatusLabel = (status) => STATUS_LABELS[status] || UNKNOWN_STATUS_LABEL;
